import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "card-body" };
const _hoisted_2 = { class: "body2-text text-black" };
const _hoisted_3 = { class: "body2-text text-black" };
const _hoisted_4 = { class: "body2-text text-black" };
const _hoisted_5 = { class: "body2-text text-black" };
const _hoisted_6 = { class: "body2-text text-black" };
const _hoisted_7 = { class: "body2-text text-black" };
const _hoisted_8 = { class: "body2-text text-black" };
const _hoisted_9 = { class: "body2-text text-black" };
const _hoisted_10 = { class: "body2-text text-black" };
const _hoisted_11 = { class: "body2-text text-black" };
const _hoisted_12 = { class: "body2-text text-black" };
const _hoisted_13 = { class: "body2-text text-black" };
const _hoisted_14 = { class: "body2-text text-black" };
const _hoisted_15 = { class: "body2-text text-black" };
const _hoisted_16 = { class: "body2-text text-black" };
const _hoisted_17 = { class: "body2-text text-black" };
const _hoisted_18 = { class: "body2-text text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputRow = _resolveComponent("InputRow");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" 카드단말기 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}card_device`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.cardDeviceType), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 락타임 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}order_delay_time_second`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.orderDelayTimeSecond), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 접수 목록 제한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}accepted_order_view_limit_count`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.acceptedOrderViewLimitCount), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 배차 제한잔액 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}allocate_limit_baromoney`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.allocateLimitBaromoney), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 최대 배차 가능 건 수  "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}max_allocate_count`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.maxAllocateCount), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 배차 후 완료가능 최소 시간 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}min_finish_minute_after_allocated`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.minFinishMinuteAfterAllocated), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" GPS 활성화 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}is_gps_on`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.isForceGpsOn), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 공유배달 표기 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}is_share_order_hidden`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.isSharedOrderHidden), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 배차취소 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_cancel_allocate`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.isPossibleToCancelAllocatedOrder), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 픽업예정시간 수정 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_calcel_allocated_order`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.isImpossibleToChangePickupExpectedAt), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 도착지 주소 수정 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_change_drop_address`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.isPossibleToChangeDropAddress), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 결제수단 변경 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_change_payment_authority_type`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.changePaymentAuthorityType), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 관제 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_control_change`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.isPossibleToControl), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 상점 송금 권한 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}right_to_store_remittance`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.isPossibleToSendHubBaromoney), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 라이더 수수료 그룹 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_delivery_fee_group`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.workerDeliveryFeeGroupName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 자동 차감 그룹  "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}cash_auto_deduct_group`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.workerCashAutoDeductGroupName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createCommentVNode(" 배차취소 패널티 그룹  "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}allocated_cancel_penalty_group`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.workerPenaltyGroupName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
    ]));
}
